export default __webpack_public_path__ + "static/media/binancee.92643887.png";